import React, { useState, useEffect } from "react";
import { Button, Spin, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import bgImage from "../assets/bg.jpeg";
import "./LoginPage.css";

const { Title, Text } = Typography;

// Base API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://arxed.info";
// const API_BASE_URL = "http://localhost:8000";
function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("Authentication required");
  const navigate = useNavigate();

  const handleLogin = () => {
    setLoading(true);
    window.location.href = `${API_BASE_URL}/api/login?next=/#/search`;
  };

  return (
    <div className="login-page" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="top-header">
        <div className="logo-container">
          <img
            src={`${process.env.PUBLIC_URL}/logo.webp`}
            alt="ArxEd Logo"
            className="logo-image"
          />
        </div>
        <a
          href="https://www.arxed.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="about-us-button"
        >
          About us
        </a>
      </div>

      <div className="login-content">
        {loading ? (
          <div className="loading-container">
            <Spin size="large" />
            <p>Checking authentication status...</p>
          </div>
        ) : error ? (
          <div className="login-info">
            <div className="title-container">
              <Title level={1} className="main-title">
                Contract
              </Title>
              <Title level={1} className="main-title">
                Search System
              </Title>
            </div>
            <div className="action-container-horizontal">
              <Button
                type="primary"
                size="large"
                onClick={handleLogin}
                className="get-started-button-inline"
              >
                Get Started
              </Button>

              <Text className="slogan-inline">
                Unlocking insights, <br /> simplifying contract management
              </Text>
            </div>
          </div>
        ) : null}
      </div>

      <div className="login-footer">
        <Text className="copyright-text">
          Copyright @ 2025 ArxEd, Inc. All Rights Reserved.
        </Text>
      </div>
    </div>
  );
}

export default LoginPage;
